import axiosInstance from "../config/axios.config";

export const SERVICE_REQUESTS_COUNT_UPDATED_EVENT =
  "serviceRequestsCountUpdated";

export const fetchServiceRequestsCounts = () => {
  return axiosInstance.get(`/careservices/fetch-service-requests-counts/`);
};

export const refreshServiceRequestsCount = async () => {
  const res = await fetchServiceRequestsCounts();
  const pending = res?.data?.data?.total_pending ?? 0;
  window.dispatchEvent(
    new CustomEvent(SERVICE_REQUESTS_COUNT_UPDATED_EVENT, {
      detail: { pending },
    })
  );
  return pending;
};

export const listServiceRequestsApi = (params) => {
  return axiosInstance.get(`/careservices/service-requests/list/?${params}`);
};

export const approveRejectServiceRequestApi = (id, payload) => {
  return axiosInstance.post(`/careservices/service-requests/${id}/process/`, payload);
};